import { createAction } from "@ngrx/store";

export const createLicence = createAction("[Licence] Create licence", (licence: any) => ({ licence }))
export const createLicenceSuccess = createAction("[Licence] Create licence Success", (reponseDAO) => ({ reponseDAO }))
export const createLicenceFailure = createAction("[Licence] create Licence failure", (error) => ({ error }))

export const getLicence = createAction("[Licence] Get all Licence", (element: string, page: number, size: number, utilisateurId: number) => ({ element, page, size, utilisateurId }));
export const getLicenceSuccess = createAction("[Licence] Get all Licence success", (licences: any) => ({ licences }))
export const getLicenceFailure = createAction("[Licence] Get all Licence Failure", (error: any) => ({ error }))

export const deleteLicence = createAction("[Licence] Delete Licence", (id: number) => ({ id }))
export const deleteLicenceSuccess = createAction("[Licence] Delete Licence Success")
export const deleteLicenceFailure = createAction("[Licence] Delete Licence Failure", (error: any) => ({ error }))
